import { createSlice } from '@reduxjs/toolkit';

import { ROWS_PER_PAGE } from '../../utils/constants';

const initialState = {
  view: 'grid',
  criteria: '',
  type: null,
  level: null,
  objective: null,
  muscleGroup: null,
  duration: [0, 240],
  calories: [0, 5000],
  favoritesOnly: false,

  rowsPerPage: ROWS_PER_PAGE,
  page: 1,
};

export const workoutSearchFiltersSlice = createSlice({
  name: 'workoutSearchFilters',
  initialState,
  reducers: {
    setWorkoutSearchFilters: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
  selectors: {
    selectWorkoutSearchFilters: (state) => state,
  },
});

export const { setWorkoutSearchFilters } = workoutSearchFiltersSlice.actions;
export const { selectWorkoutSearchFilters } = workoutSearchFiltersSlice.selectors;
export default workoutSearchFiltersSlice.reducer;
